import React, { Fragment } from 'react';
import { Parallax } from 'react-scroll-parallax';
import { ReactSVG } from 'react-svg';
import Media from 'react-media';
import { MOBILE_WIDTH } from '../../constants';
import Showcase from '../common/Showcase';
import circlePatBig from '../../assets/shapes/circlePatBig.svg';
import og from '../../assets/shapes/og.svg';
import downArrow from '../../assets/shapes/downArrow.svg';
import styles from './Goal.module.scss';
import imageSource from '../../assets/screenshots/1-editGoal.png';

const editGoal = {
	title: 'Goals',
	content: 'We all want to be better at something. Start by setting some broad goals and then define the patterns that will help you get there.',
	featureTitle: 'Features',
	features: [
		'With your reason, define your "why" so you never lose sight of it.',
		'Easily add new patterns.',
		'Choose inspirational content to fuel you.',
	],
	imageSource,
};

const Goal = (props) => {
	const { shapeCluster01, primaryOrange, ogStyle, shapeCluster02, arrowStyle, centerCluster, centerStyle, center, centerSM, border, goalContainer } =
		styles;

	return (
		<Fragment>
			<Media query={{ maxWidth: MOBILE_WIDTH }}>
				{(matches) => (
					<Showcase item={editGoal} bubbleStyle={border} containerClass={`${matches ? goalContainer : null}`}>
						<div className={shapeCluster01}>
							<Parallax translateY={[310, 30]} className={ogStyle}>
								<ReactSVG src={og} />
							</Parallax>
						</div>

						<div className={shapeCluster02}>
							<Parallax translateY={[-50, 600]} className={arrowStyle}>
								<ReactSVG src={downArrow} style={{ fill: primaryOrange }} />
							</Parallax>
						</div>

						<div className={centerCluster}>
							<Parallax translateY={[100, -100]} className={centerStyle}>
								<ReactSVG src={circlePatBig} className={`${matches ? centerSM : center}`} />
							</Parallax>
						</div>
					</Showcase>
				)}
			</Media>
		</Fragment>
	);
};

export default Goal;
